import Button from 'components/button/Button';
import { useTranslation } from 'react-i18next';
import useAddCustomFieldModal from './useAddCustomFieldModal';

const AddCustomFieldButton = () => {
  const { openAddCustomFieldModal } = useAddCustomFieldModal();
  const { t } = useTranslation();

  return (
    <Button
      bsStyle="primary"
      onClick={openAddCustomFieldModal}
      data-testid="add-custom-field-button"
    >
      {t('pageAutomations.customFields.addCustomField')}
    </Button>
  );
};

export default AddCustomFieldButton;
